import {Box} from "@mui/material";
import {ErrorAlert} from "@variocube/app-ui";
import React from "react";
import {useAsync} from "react-async-hook";
import {LegalSettings, useTenantApi} from "../../api";
import {useReloadTenant, useTenantId} from "../../tenant";
import {LegalSettingsEditForm} from "./LegalSettingsEditForm";

export function TenantLegalSettings() {
	const tenantId = useTenantId();
	const {getTenantLegalSettings, updateTenantLegalSettings} = useTenantApi();
	const reloadTenant = useReloadTenant();
	const {loading, error, result} = useAsync(getTenantLegalSettings, [tenantId]);

	async function handleSave(legalSettings: LegalSettings) {
		await updateTenantLegalSettings(tenantId, legalSettings);
		await reloadTenant();
	}

	if (error) {
		return <ErrorAlert error={error} />;
	}

	return (
		<Box maxWidth="sm">
			<LegalSettingsEditForm loading={loading} onSave={handleSave} legalSettings={result} />
		</Box>
	);
}
